/*                                     */
/**
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/async/namespaces";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 */
export const misc = asExport(o_util, "misc", {});
/**
 *
 *
 *
 */
export const getPagecluster = asExport(misc, "getPagecluster", noop);
/**
 *
 *
 *
 */
export const guid = asExport(misc, "guid", noop);
/**
 *
 *
 *
 */
export const isPreview = asExport(misc, "isPreview", noop);
/**
 *
 *
 *
 */
export const isPrivacyPage = asExport(misc, "isPrivacyPage", noop);
/**
 *
 *
 *
 */
export const isValidMouseButton = asExport(misc, "isValidMouseButton", noop);
/**
 *
 *
 *
 */
export const nanoid = asExport(misc, "nanoid", noop);
/**
 *
 *
 *
 */
export const urlToLinkObject = asExport(misc, "urlToLinkObject", noop);
/**
 *
 */
export const setVendorStyle = asExport(misc, "setVendorStyle", noop);
/**
 *
 */
export const isResponsive = asExport(misc, "isResponsive", noop);
